import sendLocalRequest from "./sendLocalRequest";

export const getMachineStatus = (auth_token, uniqueId) => {
    return  new Promise( (resolve, reject) => {
        sendLocalRequest(`machines/${uniqueId}`, "GET", auth_token).then( (data) => {
            resolve(data);
        }).catch( (error) => {
            reject(error);
        })
    });



};
